export const save = (name, content) => {
    if (!name) {
        return
    }

    window.localStorage.setItem(name, JSON.stringify(content))
}

export const restore = name => {
    if (!name) {
        return
    }

    return JSON.parse(window.localStorage.getItem(name))
}

export const remove = name => {
    if (!name) {
        return
    }

    window.localStorage.removeItem(name)
}


// WEBPACK FOOTER //
// ./src/utils/storage.js